// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pgmlist_buttons_container {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 20px;
  align-items: center;
  width: 98%;
  margin: 1rem auto;
  border-bottom: 1px solid #C1C6D0;
}
.pgmlist_buttons_container .pgmlist_btns {
  display: flex;
  width: 70%;
  gap: 1rem;
}
.pgmlist_buttons_container .pgmlist_btns .partner-excel-download {
  height: 40px;
}
.pgmlist_buttons_container .pgmlist_btns .Pgmlist_active_button {
  width: 100%;
  height: 40px;
  left: 299px;
  top: 122px;
  background: #0C3688;
  border-radius: 8px 8px 0px 0px;
  font-family: "Poppins";
  font-style: normal;
  font-weight: 600;
  font-size: 15px;
  border: none;
  color: #FFFFFF;
}
.pgmlist_buttons_container .pgmlist_btns .pgmlist_button {
  width: 100%;
  height: 40px;
  background: #E5F0FF;
  border-radius: 8px 8px 0px 0px;
  font-family: "Poppins";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  color: #7C87A1;
  border: none;
  white-space: nowrap;
}
.pgmlist_buttons_container .pgmlist_btns .pgmlist_Add {
  width: 20%;
  height: 40px;
  background: #E5F0FF;
  border-radius: 8px 8px 0px 0px;
  font-family: "Poppins";
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  color: #7C87A1;
  border: none;
}

@media screen and (max-width: 768px) {
  .pgmlist_buttons_container {
    flex-direction: column;
    border-bottom: 0;
    gap: 20px;
  }
  .pgmlist_buttons_container .pgmlist_btns {
    width: 100%;
    border-bottom: 1px solid #C1C6D0;
  }
}
@media screen and (max-width: 468px) {
  .pgmlist_btns {
    width: 100%;
    border-bottom: 1px solid #C1C6D0;
    flex-wrap: wrap;
  }
  .download-excel {
    width: 100%;
  }
  .pgmlist_button, .Pgmlist_active_button {
    width: 47% !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/component/ButtonsComponent/buttons.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,8BAAA;EACA,eAAA;EACA,SAAA;EACA,mBAAA;EACA,UAAA;EACA,iBAAA;EACA,gCAAA;AACF;AACE;EACE,aAAA;EACA,UAAA;EACA,SAAA;AACJ;AACI;EACE,YAAA;AACN;AAEI;EACE,WAAA;EACA,YAAA;EACA,WAAA;EACA,UAAA;EACA,mBAAA;EACA,8BAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,YAAA;EACA,cAAA;AAAN;AAGI;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,8BAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,YAAA;EACA,mBAAA;AADN;AAII;EACE,UAAA;EACA,YAAA;EACA,mBAAA;EACA,8BAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,YAAA;AAFN;;AAQA;EACE;IACE,sBAAA;IACA,gBAAA;IACA,SAAA;EALF;EAOE;IACE,WAAA;IACA,gCAAA;EALJ;AACF;AAaA;EAEI;IACE,WAAA;IACA,gCAAA;IACA,eAAA;EAZJ;EAeE;IACE,WAAA;EAbJ;EAgBE;IACE,qBAAA;EAdJ;AACF","sourcesContent":[".pgmlist_buttons_container {\n  display: flex;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: 20px;\n  align-items: center;\n  width: 98%;\n  margin: 1rem auto;\n  border-bottom: 1px solid #C1C6D0;\n\n  .pgmlist_btns {\n    display: flex;\n    width: 70%;\n    gap: 1rem;\n\n    .partner-excel-download {\n      height: 40px;\n    }\n\n    .Pgmlist_active_button {\n      width: 100%;\n      height: 40px;\n      left: 299px;\n      top: 122px;\n      background: #0C3688;\n      border-radius: 8px 8px 0px 0px;\n      font-family: 'Poppins';\n      font-style: normal;\n      font-weight: 600;\n      font-size: 15px;\n      border: none;\n      color: #FFFFFF;\n    }\n\n    .pgmlist_button {\n      width: 100%;\n      height: 40px;\n      background: #E5F0FF;\n      border-radius: 8px 8px 0px 0px;\n      font-family: 'Poppins';\n      font-style: normal;\n      font-weight: 400;\n      font-size: 14px;\n      color: #7C87A1;\n      border: none;\n      white-space: nowrap;\n    }\n\n    .pgmlist_Add {\n      width: 20%;\n      height: 40px;\n      background: #E5F0FF;\n      border-radius: 8px 8px 0px 0px;\n      font-family: 'Poppins';\n      font-style: normal;\n      font-weight: 400;\n      font-size: 15px;\n      color: #7C87A1;\n      border: none;\n\n    }\n  }\n}\n\n@media screen and (max-width:768px) {\n  .pgmlist_buttons_container {\n    flex-direction: column;\n    border-bottom: 0;\n    gap: 20px;\n\n    .pgmlist_btns {\n      width: 100%;\n      border-bottom: 1px solid #C1C6D0;\n    }\n\n    // .pgmlist_button, .Pgmlist_active_button{\n    //   width: 20% !important;\n    // }\n  }\n}\n\n@media screen and (max-width:468px) {\n\n    .pgmlist_btns {\n      width: 100%;\n      border-bottom: 1px solid #C1C6D0;\n      flex-wrap: wrap;\n    }\n\n    .download-excel{\n      width: 100%;\n    }\n\n    .pgmlist_button, .Pgmlist_active_button{\n      width: 47% !important;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
